import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'clsx';
import { bindActionCreators } from 'redux';
import WideHeader from '../landing/WideHeader';
import { logSubscribeActivity } from '../../actions/logging';
import { selectIsSubscriptionEnabled } from '../../selectors/config';
import { selectIsUserSubscribed } from '../../selectors/me';
import { selectBreakpoint } from '../../selectors/app';
import css from './tall-page-header.module.scss';

export const TallPageHeader = ({
  headerTitle,
  isSubscriptionEnabled,
  isUserSubscribed,
  breakpoint,
  logSubActivity,
  headerTitleClassName,
  hideAuthLinks = false,
}) => (
  <>
    <WideHeader
      subscriptionEnabled={isSubscriptionEnabled}
      isUserSubscribed={isUserSubscribed}
      logSubscribeActivity={logSubActivity}
      hideAuthLinks={hideAuthLinks}
      breakpoint={breakpoint}
      areColorsInverted
    />
    <div className={css.headerSection} data-testid="headerSection">
      <span
        className={classnames(css.headerTitle, headerTitleClassName)}
        data-testid="headerTitle"
      >
        {headerTitle}
      </span>
    </div>
  </>
);

TallPageHeader.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  isSubscriptionEnabled: PropTypes.bool.isRequired,
  isUserSubscribed: PropTypes.bool.isRequired,
  breakpoint: PropTypes.number.isRequired,
  logSubActivity: PropTypes.func.isRequired,
  headerTitleClassName: PropTypes.string,
  hideAuthLinks: PropTypes.bool,
};

TallPageHeader.defaultProps = {
  headerTitleClassName: '',
};

// exported for testing
const mapStateToProps = (state) => ({
  isSubscriptionEnabled: selectIsSubscriptionEnabled(state),
  isUserSubscribed: selectIsUserSubscribed(state),
  breakpoint: selectBreakpoint(state),
});

// exported for testing
function mapDispatchToProps(dispatch) {
  return { logSubActivity: bindActionCreators(logSubscribeActivity, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(TallPageHeader);
